import React from 'react';
import Testimonial from '../components/Testimonial';
import { Link } from 'react-router-dom';

const Home = () => {
  const img = (path) => process.env.PUBLIC_URL + path;

  return (
    <div className="boxed_wrapper ltr">

     {/* Banner Section */}
<section
  className="banner-style-two centred"
  style={{
    backgroundImage: "url('/assets/images/banner/slide02.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative'
  }}
>
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.712)',
      zIndex: 1
    }}
  ></div>
  <div className="auto-container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="inner-box">
      <div className="content-box pb_120">
        <h2 style={{ color: '#fff' }}>
          Quality Professional <span>Translation</span> Services for You
        </h2>
        <p style={{ color: '#f0f0f0' }}>
          We are committed to confidentiality, timely delivery, and competitive pricing, with a <br />
          strong focus on meeting your expectations.
        </p>
        <div className="btn-box">
          <Link to="/about" className="theme-btn btn-one">Explore More</Link>
          <Link to="/contact" className="theme-btn btn-two">Get Started</Link>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Features Section */}
      <section className="feature-style-three pb_150 centred pt-5">
        <div className="pattern-layer pt-3">
          <div className="pattern-1" style={{ backgroundImage: "url('/assets/images/shape/shape-34.png')" }}></div>
          <div className="pattern-2" style={{ backgroundImage: "url('/assets/images/shape/shape-35.png')" }}></div>
        </div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="shape" style={{ backgroundImage: "url('/assets/images/shape/shape-33.png')" }}></div>
            <div className="row clearfix">
              {[
                {
                  icon: 'icon-16',
                  title: 'Expertise You Can Trust',
                  text: 'Industry specialists, we deliver translations that are not only accurate but also culturally relevant.'
                },
                {
                  icon: 'icon-17',
                  title: 'Commitment to Quality',
                  text: 'Every project undergoes rigorous quality checks to guarantee precision and consistency.'
                },
                {
                  icon: 'icon-18',
                  title: 'Fast and Reliable Delivery',
                  text: 'We value your time and ensure timely completion without compromising on quality.'
                }
              ].map((item, idx) => (
                <div key={idx} className="col-lg-4 col-md-6 col-sm-12 feature-block">
                  <div className="feature-block-two">
                    <div className="inner-box">
                      <div className="icon-box"><i className={item.icon}></i></div>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-style-three pb_150 pt-5" style={{ background: '#fff' }}>
        <div className="auto-container pt-3">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
              <div className="image_block_five">
                <div className="image-box mr_80">
                  <figure className="image"><img src="/assets/images/resource/about-5.jpg" alt="" /></figure>
                  <ul className="image-content clearfix">
                    <li><div className="icon"><img src="/assets/images/icons/icon-7.png" alt="" /></div><h6>Manual Subtitle</h6></li>
                    <li className="load"><div className="icon"><img src="/assets/images/icons/icon-8.png" alt="" /></div><h6>Auto Translate</h6></li>
                    <li><div className="icon"><img src="/assets/images/icons/icon-9.png" alt="" /></div><h6>Upload Texts</h6></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content_block_four">
                <div className="content-box ml_40">
                  <div className="sec-title mb_25">
                    <span className="sub-title overlay-anim-white-bg">About Wications</span>
                    <h2>Precise & Culturally Rooted Translation Services</h2>
                  </div>
                  <div className="text-box mb_40">
                    <p>Wications is a professional translation company dedicated to bridging communication gaps across Sri Lanka and South India...</p>
                  </div>
                  <div className="inner-box">
                    <div className="single-item mb_40">
                      <div className="icon-box"><i className="icon-13"></i></div>
                      <h3>Regional Language Expertise</h3>
                      <p>Specialized in Sinhala, Tamil, Malayalam, Kannada, and Telugu...</p>
                    </div>
                    <div className="single-item">
                      <div className="icon-box"><i className="icon-14"></i></div>
                      <h3>Industry-Focused Solutions</h3>
                      <p>From legal documents to marketing, e-learning, and media...</p>
                    </div>
                  </div>
                  <div className="btn-box pt-3">
                    <Link to="/about" className="theme-btn btn-one">Know More</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Section */}
      <section className="service-style-two pb_150">
        <div className="pattern-layer" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-41.png')})` }}></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="shape" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-40.png')})` }}></div>
            <div className="sec-title mb_55 centred">
              <span className="sub-title overlay-anim-white-bg">Our Exclusive Services</span>
              <h2>Service Included</h2>
            </div>
            <div className="row clearfix">
              {[
                {
                  title: 'Subtitle & Voice Over',
                  text: 'Enhance your multimedia content with professional subtitling and voiceover services'
                },
                {
                  title: 'Proofreading',
                  text: 'Translate your documents into a polished format with our specialist proofreading services.'
                },
                {
                  title: 'Translations Services',
                  text: 'Translation services help you communicate well within more than 80 languages professionally.'
                },
                {
                  title: 'Website Localization',
                  text: 'Expand your online presence globally with our website localization services.'
                }
              ].map((item, idx) => (
                <div className="col-lg-3 col-md-6 col-sm-12 service-block" key={idx}>
                  <div className="service-block-one">
                    <div className="inner-box">
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                      <div className="link"><a href="/services"><i className="icon-23"></i></a></div>
                      <figure className="image"><img src={img('/assets/images/shape/shape-46.png')} alt="" /></figure>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-style-three pb_140">
        <div className="pattern-layer" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-44.png')})` }}></div>
        <div className="auto-container">
          <div className="sec-title mb_55 centred">
            <span className="sub-title overlay-anim-white-bg">General Faq’s</span>
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="inner-box mr_30">
                <ul className="accordion-box">
                  {[
                    {
                      q: 'What translation services does Wications offer?',
                      a: 'We offer translation, transcription, subtitling, voice-over, and localization in Sinhala, Tamil, Telugu, Malayalam, and Kannada.'
                    },
                    {
                      q: 'Do you handle industry-specific content?',
                      a: 'Yes. Our linguists specialize in legal, medical, technical, and educational domains.'
                    },
                    {
                      q: 'How long does it take to complete a project?',
                      a: 'It depends on project size. Most documents are completed in 1–3 business days.'
                    },
                    {
                      q: 'Which languages do you specialize in?',
                      a: 'Sinhala, Tamil, Malayalam, Telugu, and Kannada — with multilingual support.'
                    },
                    {
                      q: 'Is my data and content kept confidential?',
                      a: 'Absolutely. We follow strict protocols and sign NDAs when requested.'
                    }
                  ].map((item, idx) => (
                    <li key={idx} className={`accordion block ${idx === 0 ? 'active-block' : ''}`}>
                      <div className={`acc-btn ${idx === 0 ? 'active' : ''}`}>
                        <div className="icon-box"></div>
                        <h4>{item.q}</h4>
                      </div>
                      <div className={`acc-content ${idx === 0 ? 'current' : ''}`}>
                        <div className="text"><p>{item.a}</p></div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
              <div className="image-box ml_30">
                <figure className="image"><img src={img('/assets/images/resource/faq-1.jpg')} alt="FAQ" /></figure>
              </div>
            </div>
          </div>
        </div>
      </section>

            {/* Glance Section */}
            <section className="glance-section centred">
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              {[5, 6, 7, 8, 9].map((num, index) => (
                <div
                  key={index}
                  className={`pattern-${index + 1} ${index >= 2 ? 'rotate-me' : ''}`}
                  style={{ backgroundImage: `url(${img('/assets/images/shape/shape-' + num + '.png')})` }}
                ></div>
              ))}
            </div>
            <div className="sec-title light mb_80">
              <span className="sub-title">Wications' Vision</span>
              <h2>Empowering Regional Voices <br />Through Expert Translations</h2>
              <p>
                <strong>Wications</strong> is committed to delivering impactful, high-quality translations in Sri Lankan and South Indian languages including Sinhala, Tamil, Malayalam, Telugu, and Kannada. Our vision is to create seamless communication across cultures by making local languages accessible to global platforms. Whether it’s legal, educational, medical, or marketing content, we ensure that your message retains its intent, tone, and cultural context—no matter the language.
              </p>
            </div>
          </div>
        </div>
      </section>

    {/* Testimonial Section */}
    
      <Testimonial />

      {/* CTA Section */}
      <section className="cta-section">
        <div className="bg-color"></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              {[23, 24, 25, 26].map(n => (
                <div key={n} className={`pattern-${n - 22} ${n !== 23 ? 'rotate-me' : ''}`} style={{ backgroundImage: `url(${img('/assets/images/shape/shape-' + n + '.png')})` }}></div>
              ))}
            </div>
            <div className="inner-box">
              <h2>Let’s Bridge the Language Gap – <br />Get Started Now</h2>
          
              <div className="btn-box pt-3">
                <Link to="/contact" className="theme-btn btn-one">Get Started</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;